import { useSessionStorage } from "usehooks-ts";

/**
 * Session-storage flag telling us a Bridge bank sync is in progress. It is set
 * on the home route when the user comes back from Bridge with `?success=true`,
 * and cleared by <BankSyncTracker /> once the sync reaches a terminal state (or
 * times out).
 *
 * Living in session storage (via usehooks-ts, which syncs across components in
 * the same tab) means the tracker keeps working when the home route navigates
 * to `/transactions` and even survives a page reload — the previous
 * implementation lived on the home component and lost all state the moment it
 * unmounted.
 */
export const BRIDGE_SYNC_ACTIVE_KEY = "bridge-sync-active";

export function useBridgeSyncActive() {
  return useSessionStorage(BRIDGE_SYNC_ACTIVE_KEY, false);
}
